import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Bot, Save, RotateCcw } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AIKnowledgeEditor() {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [original, setOriginal] = useState('');
  const [meta, setMeta] = useState({});
  const [saving, setSaving] = useState(false);
  const token = localStorage.getItem('customerAdminToken');

  useEffect(() => {
    if (!token) { navigate('/customer-admin/login'); return; }
    fetch(`${API_URL}/api/customer-admin/ai-knowledge`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { setContent(d.content || ''); setOriginal(d.content || ''); setMeta(d); })
      .catch(() => toast.error('Failed to load AI knowledge'));
  }, [token, navigate]);

  const save = async () => {
    setSaving(true);
    try {
      const r = await fetch(`${API_URL}/api/customer-admin/ai-knowledge`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ content })
      });
      if (!r.ok) throw new Error();
      const d = await r.json();
      setOriginal(d.content); setMeta(d);
      toast.success('AI knowledge saved — chatbot will use it immediately');
    } catch { toast.error('Save failed'); } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6" data-testid="ai-knowledge-page">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
          <div className="flex items-center gap-3">
            <Button variant="outline" onClick={() => navigate('/customer-admin/dashboard')} data-testid="ai-knowledge-back-btn">
              <ArrowLeft className="h-4 w-4 mr-1" /> Dashboard
            </Button>
            <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2"><Bot className="h-6 w-6 text-red-600" /> Netix AI Knowledge</h1>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => setContent(original)} disabled={content === original} data-testid="ai-knowledge-reset-btn">
              <RotateCcw className="h-4 w-4 mr-1" /> Reset
            </Button>
            <Button onClick={save} disabled={saving || content === original || content.trim().length < 20} className="bg-red-600 hover:bg-red-700 text-white" data-testid="ai-knowledge-save-btn">
              <Save className="h-4 w-4 mr-1" /> {saving ? 'Saving...' : 'Save'}
            </Button>
          </div>
        </div>
        <p className="text-sm text-gray-600 mb-3">
          Yeh text website chatbot (Netix AI) ka knowledge base hai — plans, prices, coverage cities, recharge rules, offers yahan update karein. Bot sirf isi jaankari se jawab deta hai.
          {meta.updated_at && <span className="block text-xs text-gray-400 mt-1">Last updated {new Date(meta.updated_at).toLocaleString('en-IN')} by {meta.updated_by}</span>}
        </p>
        <textarea
          value={content}
          onChange={e => setContent(e.target.value)}
          data-testid="ai-knowledge-textarea"
          className="w-full h-[65vh] font-mono text-sm p-4 border-2 border-gray-200 rounded-xl focus:border-red-400 focus:outline-none bg-white"
        />
      </div>
    </div>
  );
}
